<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-row
            class="flex-child"
        >
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-container fluid>
                        <v-row align="center">
                            <v-col cols="12" md="2" sm="3" xs="3">
                                <v-select
                                    @change="pageChange"
                                    :items="classItems"
                                    :label="$vuetify.lang.t('$vuetify.custom.score.class')"
                                    hide-details
                                    solo
                                    v-model="searchData.classId"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-text-field
                                    solo
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.score.studentName')"
                                    v-model="searchData.studentName"
                                />
                            </v-col>
                            <v-col cols="12" md="1" sm="3" xs="3">
                                <v-row justify="end">
                                    <v-btn v-5="permissionCode.search" color="primary mr-3" @click="pageChange" dark large>
                                        <v-icon left>mdi-magnify</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.searchBtn') }}
                                    </v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="desserts"
                        item-key="id"
                        class="elevation-1"
                        :loading="loading"
                        :footer-props="footerProps"
                        :loading-text="loadingText"
                        :options.sync="options"
                        :server-items-length="totalDesserts"
                        @update:options="changeOptions"

                    >
                        <template v-slot:item.thisRankStr="{ item }">
                            <v-badge
                                :color="getIconsStyle(item)"
                                :content="getIcons(item)"
                            >
                                {{ item.thisRankStr }}
                            </v-badge>
                        </template>
                        <template v-slot:item.thisScoreStr="{ item }">
                            <v-badge
                                :color="getIconsScoreStyle(item)"
                                :content="getScoreIcons(item)"
                            >
                                {{ item.thisScoreStr }}
                            </v-badge>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn color="normal" v-5="permissionCode.detail" x-small @click="showDetailDialog(item)">
                                <v-icon small>
                                    mdi-account-details
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.detail') }}
                            </v-btn>
                            <v-btn color="normal" v-5="permissionCode.update" x-small @click="updateItem(item)" class="ml-2">
                                <v-icon small>
                                    mdi-update
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.school.update') }}
                            </v-btn>
                            <v-btn class="ml-2" v-5="permissionCode.teacherAppraise" color="normal" x-small @click="teacherAppraise(item)">
                                <v-icon small>
                                    mdi-teach
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.score.appraise') }}
                            </v-btn>
                            <v-btn class="ml-2" v-5="permissionCode.followRecord" color="normal" x-small @click="recordItem(item)">
                                <v-icon small>
                                    mdi-account-arrow-right
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.score.record') }}
                            </v-btn>
                            <v-btn color="normal" v-5="permissionCode.supplementScore" x-small @click="supplementScore(item)" class="ml-2">
                                <v-icon small>
                                    mdi-layers-plus
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.student.supplementScore') }}
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-sheet>
            </v-col>
            <v-dialog v-model="showDetail" max-width="1000px">
                <score-detail v-model="showDetail" :stuDetailMsg="stuDetailMsg"></score-detail>
            </v-dialog>
            <v-dialog
                v-model="appraiseDialog"
                max-width="500px"
                persistent
            >
                <v-card>
                    <v-card-title>
                        评价
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    outlined
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.score.appraise')"
                                    v-model="appraise"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-file-input accept="image/*" v-model="appraiseFile" label="请选择图像文件"></v-file-input>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="error" dark
                            @click="teacherAppraiseCancel"
                        >
                            取消
                        </v-btn>
                        <v-btn
                            color="success" dark @click="appraiseBtn"
                        >
                            评价
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="recordDialog"
                max-width="500px"
                persistent
            >
                <v-card>
                    <v-card-title>
                        跟踪记录
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    outlined
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.score.record')"
                                    v-model="record"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-file-input accept="image/*" v-model="recordFile" label="请选择图像文件"></v-file-input>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="error" dark
                            @click="recordCancel"
                        >
                            取消
                        </v-btn>
                        <v-btn
                            color="success" dark @click="recordBtn"
                        >
                            记录
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-dialog v-model="dialog" max-width="700px">
            <score-update v-model="dialog" @initialize="pageChange" :scoreMsg="scoreMsg"></score-update>
        </v-dialog>
        <v-dialog v-model="suppDialog" persistent max-width="700px">
            <score-supplement v-model="suppDialog" :stuId="studentId"></score-supplement>
        </v-dialog>
    </v-container>
</template>
<style></style>
<script>
import Mock from 'mockjs';
import scoreDetail from './score-detail'
import scoreUpdate from './score-update'
import scoreSupplement from './score-supplement'

export default {
    data() {
        return {
            permissionCode:{
                search:'biz:score:search',
                detail:'biz:score:detail',
                update:'biz:score:update',
                teacherAppraise:'biz:score:teacher:appraise',
                followRecord:'biz:score:follow:record',
                supplementScore:'biz:score:supplement:score',
            },
            studentId: '',
            suppDialog: false,
            scoreMsg: {},
            dialog: false,
            appraiseFile: '',
            recordFile: '',
            stuDetailMsg: {},
            record: '',
            recordDialog: false,
            appraiseDialog: false,
            appraise: '',
            loading: true,
            loadingText: this.$vuetify.lang.t('$vuetify.custom.dataLoading'),
            selected: [],
            footerProps: {
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageOptions:[5,10,20,50],
                //disableItemsPerPage:true,
            },
            searchData: {
                studentName: '',
                classId: ''
            },
            options: {},
            classItems: [
                {text: this.$vuetify.lang.t('$vuetify.custom.score.pleaseSelect'), value: ''},
            ],
            headers: [
                {
                    text: this.$vuetify.lang.t('$vuetify.custom.score.class'),
                    value: 'className',
                },
                {text: this.$vuetify.lang.t('$vuetify.custom.score.name'), value: 'studentName'},
                {text: this.$vuetify.lang.t('$vuetify.custom.score.preRank'), value: 'lastRankStr'},
                {text: this.$vuetify.lang.t('$vuetify.custom.score.currRank'), value: 'thisRankStr'},
                {text: this.$vuetify.lang.t('$vuetify.custom.score.preScore'), value: 'lastScoreStr'},
                {text: this.$vuetify.lang.t('$vuetify.custom.score.currScore'), value: 'thisScoreStr'},
                {text: this.$vuetify.lang.t('$vuetify.custom.actions'), value: 'actions', sortable: false},
            ],
            totalDesserts: 0,
            desserts: [],
            showDetail: false,
            formData: {
                stuId: '',
                examId: '',
                comment: '',
                recordType: 0,//0老师评价 1导员跟踪
                fileIds: [],
            }
        }

    },
    mounted() {
        this.initClassItems();
    },
    methods: {
        pageChange(){
            this.options.page = 1
            this.initialize()
        },
        supplementScore(item) {
            this.suppDialog = true
            this.studentId = item.studentId
        },
        updateItem(item) {
            if (item.thisExamId == null || item.thisExamId == "") {
                this.$dialog.alert("该考生暂无成绩")
                return
            }
            this.scoreMsg = Object.assign({}, {
                id: item.thisScoreId,
                score: item.thisScore,
                examId: item.thisExamId,
            })
            this.dialog = true
        },
        teacherAppraise(item) {
            this.appraiseDialog = true
            this.formData.stuId = item.studentId
            this.formData.examId = item.thisExamId
            this.formData.recordType = 0
        },
        recordItem(item) {
            this.recordDialog = true
            this.formData.stuId = item.studentId
            this.formData.examId = item.thisExamId
            this.formData.recordType = 1
        },
        async appraiseBtn() {
            this.formData.fileIds = []
            if (this.appraise == "") {
                this.$dialog.alert("请完善信息")
                return
            }
            if (this.appraiseFile != "" && this.appraiseFile != null) {
                let form = new FormData();
                form.append("filePath", "recordFiles");
                form.append('file', this.appraiseFile);
                let files = await this.$file.fileUpload(form)
                this.formData.fileIds.push(files.fileId)
            }
            this.formData.comment = this.appraise
            this.$api.studentRecords.addStudentRecords(this.formData).then(data => {
                if (data.flag) {
                    this.$dialog.alert("评价成功");
                    this.initialize()
                    this.appraiseDialog = false
                    this.appraise = ''
                    this.appraiseFile = ""
                } else {
                    this.$dialog.alert(data.msg)
                }
            })
        },
        async recordBtn() {
            this.formData.fileIds = []
            if (this.record == "") {
                this.$dialog.alert("请完善信息")
                return
            }
            if (this.recordFile != "" && this.recordFile != null) {
                let form = new FormData();
                form.append("filePath", "recordFiles");
                form.append('file', this.recordFile);
                let files = await this.$file.fileUpload(form)
                this.formData.fileIds.push(files.fileId)
            }
            this.formData.comment = this.record
            this.$api.studentRecords.addStudentRecords(this.formData).then(data => {
                if (data.flag) {
                    this.$dialog.alert("评价成功");
                    this.initialize()
                    this.recordDialog = false
                    this.record = ''
                    this.recordFile = ""
                } else {
                    this.$dialog.alert(data.msg)
                }
            })
        },
        teacherAppraiseCancel() {
            this.appraiseDialog = false
            this.appraise = ''
            this.formData.stuId = ''
            this.formData.examId = ''
            this.formData.comment = ''
            this.appraiseFile = ""
            this.formData.recordType = 0
            this.formData.fileIds = []
        },
        recordCancel() {
            this.recordDialog = false
            this.record = ''
            this.formData.stuId = ''
            this.formData.examId = ''
            this.formData.comment = ''
            this.recordFile = ""
            this.formData.recordType = 1
            this.formData.fileIds = []
        },
        initClassItems() {
            this.$api.classList.getAllClass().then(data => {
                if (data.data) {
                    data.data.forEach(obj => {
                        this.classItems.push({text: obj.className, value: obj.id})
                    })
                }
            })
        },
        getIcons(item) {
            /*if ((item.thisRank - item.lastRank) < 0) return 'mdi-arrow-up'
            else if ((item.thisRank - item.lastRank) > 0) return 'mdi-arrow-down'
            else return ""*/
            return Math.abs(item.thisRank - item.lastRank);
        },
        getIconsStyle(item) {
            if ((item.thisRank - item.lastRank) < 0) return 'green accent-4'
            else if ((item.thisRank - item.lastRank) > 0) return 'red accent-4'
            else return ""
        },
        getScoreIcons(item) {
            /*if ((item.thisScore - item.lastScore) > 0) return 'mdi-arrow-up'
            else if ((item.thisScore - item.lastScore) < 0) return 'mdi-arrow-down'
            else return ""*/
            return Math.abs(item.thisScore - item.lastScore);
        },
        getIconsScoreStyle(item) {
            if ((item.thisScore - item.lastScore) > 0) return 'green accent-4'
            else if ((item.thisScore - item.lastScore) < 0) return 'red accent-4'
            else return ""
        },
        //用户详细弹窗
        showDetailDialog(item) {
            this.showDetail = true;
            this.stuDetailMsg = item
        },
        initialize() {
            this.loading = true
            this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
            this.$api.achievement.getAchievement(
                Object.assign({}, this.searchData, this.options)
            ).then(data => {
                this.loading = false;
                if (data.data) {
                    this.desserts = data.data;
                    this.totalDesserts = data.total;
                } else {
                    this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                }

            })
            // this.loading = false;
            // let data = Mock.mock({
            //     'data|10': [
            //         {
            //             'class': "et2001",
            //             'name': '@cname',
            //             "preRank|1-100": 100,
            //             "currRank|1-100": 100,
            //             "preScore|1-100": 100,
            //             "currScore|1-100": 100
            //         }
            //     ]
            // });
            // this.desserts = data.data
            // this.totalDesserts = 10;

        },
        changeOptions(option) {
            this.initialize()
        },
    },
    components: {
        scoreDetail, scoreUpdate, scoreSupplement
    },
}
</script>
